// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2z-6";
export var headerCell = "_2z-2";
export var loadingStateContent = "_2z-8";
export var rowWrapper = "_2z-4";
export var stickyAggregationCell = "_2z-b";
export var stickyAggregationRow = "_2z-7";
export var stickyColumnCell = "_2z-a";
export var stickyColumnHeaderCell = "_2z-9";
export var table = "_2z-1";
export var virtualRowWrapper = "_2z-5";
export var virtualTableBodyFiller = "_2z-d";
export var virtualTableBodyFillerBottom = "_2z-e";
export var virtualTableContainer = "_2z-0";
export var virtualTableContainerFill = "_2z-c";
export var white = "_2z-3";